import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { Button, CardDeck, Form, FormControl, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import logger from "../../../../../utils/logger";
import {
  getLocationResources,
  loadLocationResources,
  loadPins,
  markPin,
  pinsLength,
} from "../../../../controller/reducer/locationResources";
import { getLoading } from "../../../../controller/reducer/ui";
import TagSelector from "../../common/tag-selector";
import LocationItemResourceAddModal from "./add";
import LocationItemResourceCard from "./card";
import "./styles.css";

function check(title, tags, search, searchTags) {
  if (title.toLowerCase().includes(search)) {
    if (searchTags.length === 0 || tags.includes("all information"))
      return true;
    for (let i = 0; i < searchTags.length; i++) {
      if (tags.includes(searchTags[i].value)) {
        return true;
      }
    }
  }
  for (let i = 0; i < tags.length; i++) {
    if (search.includes(tags[i])) {
      return true;
    }
  }
  return false;
}

const parse = (serLocation) => {
  let search = "";
  let tags = [];
  if (serLocation === "") return { search, tags };
  const arr = serLocation.slice(1).split("&");
  arr.forEach((item) => {
    const data = item.split("=");
    const key = data[0];
    const value = data.length === 2 ? data[1] : "";
    if (key === "search") search = value;
    else if (key === "tags" && key.length > 2) {
      tags = value
        .slice(1, value.length - 1)
        .split(",")
        .map((tag) => tag.split("%20").join(" "));
    }
  });
  return { search, tags };
};

function LocationItem({ match }) {
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");
  const [tags, setTags] = useState([]);

  const dispatch = useDispatch();
  const _resources = useSelector(getLocationResources);
  const [resources, setResources] = useState(_resources);
  const pinsCount = useSelector(pinsLength);
  const { location } = useHistory();

  logger()(match.params.name);

  const loc = useCallback(
    () => match.params.name.split("_").join(" "),
    [match.params.name]
  );

  useLayoutEffect(() => {
    dispatch(loadPins(match.params.name));
  }, [dispatch]);

  const handlePin = (id, value) => {
    logger()(id, value, pinsCount);
    dispatch(markPin({ id, value }));
    if (value === true && pinsCount < 3) {
      //scroll to Top
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  // logger()(parse(location.search));
  useEffect(() => {
    logger()(location.search);
    const { search, tags } = parse(location.search);
    setSearch(search);
    setTags(tags.map((t) => ({ label: t, value: t })));
  }, [location.search]);

  useEffect(() => {
    setResources(
      _resources.filter((res) => check(res.title, res.tags, search, tags))
    );
    logger()(resources);
  }, [_resources, search, tags]);

  useEffect(() => {
    let mounted = true;

    dispatch(loadLocationResources({ name: match.params.name, mounted }));
    return () => [(mounted = false)];
  }, [dispatch, match.params.name]);

  if (useSelector(getLoading))
    return (
      <Spinner
        style={{ position: "fixed", top: "50%", right: "47%" }}
        animation="border"
      />
    );

  return (
    <div>
      <Helmet>
        <title>{`CR21 | ${loc()}`}</title>
        <meta name="description" content={`${loc()} based Covid resources`} />
      </Helmet>
      <Form inline type="submit" className="ml-4 mr-4 mt-4">
        <FormControl
          type="text"
          placeholder="Search"
          className="flex-grow-1"
          value={search}
          onChange={(e) => setSearch(e.currentTarget.value.toLowerCase())}
        />
      </Form>
      <div className="ml-4 mr-4 mt-4">
        <TagSelector isRemedy={false} tags={tags} setTags={setTags} />
      </div>
      <Form.Text className="text-muted ml-4">
        Add Resources using <span className="fabx-icon">+</span>
        {" &"} Edit Resources using{" "}
        <Button
          size="sm"
          style={{
            background: "#ffa500",
            color: "black",
            border: "none",
            fontSize: "10px",
            fontWeight: "500",
          }}
          disabled
        >
          EDIT
        </Button>
      </Form.Text>
      {resources.length > 0 ? (
        <CardDeck className="m-4 justify-content-between">
          {resources.map((res, id) => (
            <LocationItemResourceCard
              dispatch={dispatch}
              key={id}
              res={res}
              onPin={handlePin}
            />
          ))}
        </CardDeck>
      ) : (
        <p className="ml-4 mr-4 mt-4 font-weight-normal">No Resources Found</p>
      )}
      <LocationItemResourceAddModal
        show={show}
        onClose={() => setShow(false)}
        dispatch={dispatch}
      />
      <div className="fabx" onClick={() => setShow(true)}>
        +
      </div>
    </div>
  );
}

export default LocationItem;
